import { i18next } from "@translations/oarepo_dashboard";
import React from "react";

export function getReducedWorkflowHistory(record) {
  return (
    record?.map((status) => ({
      workflowExecutionId: status.workflowExecutionId,
      createdAt: status.createdAt,
      status: status.status,
    })) ?? []
  );
}

export const getReceiver = (request) => {
  if (request?.receiver?.reference?.auto_approve) return null;
  if (!Array.isArray(request.receiver)) {
    return request.receiver?.links?.self_html ? (
      <a
        href={request.receiver.links.self_html}
        target="_blank"
        rel="noopener noreferrer"
      >
        {i18next.t("Recepient: {{receiver}}.", {
          receiver: request.receiver.label,
          interpolation: { escapeValue: false },
        })}
      </a>
    ) : (
      i18next.t("Recepient: {{receiver}}.", {
        receiver: request.receiver.label,
        interpolation: { escapeValue: false },
      })
    );
  } else {
    return (
      <span>
        {i18next.t("Recepient:")}{" "}
        {request.receiver.map((receiver, index) => {
          const label =
            index === request.receiver.length - 1
              ? receiver.label
              : `${receiver.label}, `;
          return receiver?.links?.self_html ? (
            <a
              href={receiver.links.self_html}
              target="_blank"
              rel="noopener noreferrer"
              key={label}
            >
              {label}
            </a>
          ) : (
            <span key={label}>{label}</span>
          );
        })}
      </span>
    );
  }
};

export const getPublishRequest = (requests) => {
  return getRequest(requests, "publish_draft");
};

export const getWorkflowRequest = (requests) => {
  return getRequest(requests, "run_external_workflow");
};

export const getCommunitySubmissionRequest = (requests) => {
  return getRequest(requests, "community-submission");
};

function getRequest(requests, requestType) {
  if (requests) {
    return requests.find(
      (request) =>
        request.type === requestType && request.status === "submitted",
    );
  }
  return null;
}

export function getLatestDeclinedPublishedRequest(requests) {
  if (requests) {
    const declinedRequests = requests.filter(
      (request) =>
        request.type === "publish_draft" && request.status === "declined",
    );
    if (declinedRequests.length > 0) {
      return declinedRequests[0];
    }
  }
}
